// Vuex user module mutations types
export const FILL_HEADERS = 'FILL_HEADERS';
export const FILL_QUEUE = 'FILL_QUEUE';
export const FILL_STATUS_AND_TYPE_DICTIONARY = 'FILL_STATUS_AND_TYPE_DICTIONARY';
export const REMOVE_FROM_QUEUE = 'REMOVE_FROM_QUEUE';
export const FILL_HISTORY = 'FILL_HISTORY';
export const FILL_INCOMING = 'FILL_INCOMING';
export const FILL_TEMPLATES = 'FILL_TEMPLATES';
